function chkoutbtnClick(){
  if (document.getElementById('delivery-date').value == "" ) {
        //document.getElementByClass("btn cart__checkout").setAttribute("disabled", true);
        alert('「製品到着希望日」を指定してください'); 
        return false;
      };
}

//カートの商品が削除されたら、リロードして製品到着希望日をリセットする
//document.querySelectorAll('a.button--tertiary').forEach(element => {
document.querySelectorAll('a.button--tertiary, button.quantity__button').forEach(element => {
    element.addEventListener('click', () => {
        // 通常のリンク動作（商品の削除）をした後に、少し遅延してページをリロード
        setTimeout(() => {
            window.location.reload();
        }, 700);  // 700ミリ秒の遅延
    });
});

//let button2 = document.getElementById('checkout');

// addEventListener( 'イベント', 処理)で要素にイベントが発火した際に処理を実行する
//button2.addEventListener('click', chkoutbtnClick);